import {createContext, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useVideoControl} from '~/common/hooks/useVideoControls';
import {selectBackgroundColor} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

const defaultContextValue = {
  setCanvas: () => null,
  canvas: null,
  cardDesignRef: null,
  activeObjects: [],
  setActiveObjects: () => null,
  setCardDesignRef: () => null,
  effectVideo: null,
  revealVideo: null,
  processing: false,
  setProcessing: () => null,
};

export const EventCreateContext = createContext(defaultContextValue);

export const EventCreateParent = ({children}) => {
  const [canvas, setCanvas] = useState();
  const [cardDesignRef, setCardDesignRef] = useState();
  const [activeObjects, setActiveObjects] = useState();
  const backgroundColor = useSelector(selectBackgroundColor);
  const [bkgColor, setBkgColor] = useState(backgroundColor || '#c0c0c0');
  const effectVideo = useVideoControl();
  const revealVideo = useVideoControl();
  const [processing, setProcessing] = useState(false);

  const context = useMemo(
    () => ({
      canvas,
      setCanvas,
      activeObjects,
      setActiveObjects,
      cardDesignRef,
      setCardDesignRef,
      effectVideo,
      revealVideo,
      bkgColor,
      setBkgColor,
      processing,
      setProcessing,
    }),
    [
      canvas,
      setCanvas,
      activeObjects,
      setActiveObjects,
      cardDesignRef,
      setCardDesignRef,
      effectVideo,
      revealVideo,
      bkgColor,
      setBkgColor,
      processing,
      setProcessing,
    ]
  );

  return <EventCreateContext.Provider value={context}>{children}</EventCreateContext.Provider>;
};
